import { data } from 'react-router-dom';
import { get, post, put, del } from './api';


// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Order Details xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//  Create a new order with image
export const createOrder = (data) => {
  return post('/orders', data);
};

export const getAllOrders = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/orders?${query.toString()}`);
};

export const getAllCakeOrders = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/orders/cake-orders?${query.toString()}`);
};

//  Get a order by ID
export const getOrderById = (id) => {
  return get(`/orders/${id}`);
};

//  Update a order
export const updateOrder = (id, data) => {
  return put(`/orders/${id}`, data);
};

//  Delete a order 
export const deleteOrder = (id) => {
  return del(`/orders/${id}`);
};



// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Delete approval  request xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getAllDeleteRequest = (data) =>{
  return get(`/orders/pending-delete-requests`, data)
}

export const approveDeleteRequest = (id) =>{
  return put(`/orders/${id}/approve-delete`);
}

export const rejectDeleteRequest = (id) =>{
  return put(`/orders/${id}/reject-delete`);
}



// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Pdf methods xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getOrderPDF = (id) => {
  return get(`/orders/${id}/pdf`, {
    responseType: 'blob', 
  });
};

export const downloadOrderPDF = async (id) => {
  return await get(`/orders/${id}/pdf`, {
    responseType: 'blob', 
  });
};



// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Invoice Check xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const checkInvoiceNumber = (data) => {
  return post('/orders/check-invoice-number', data);
};



// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Reports xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getAllReports = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`reports/orders?${query.toString()}`);
};